__turbopack_context__.v({
  "content": "RelatedSidebar-module__njuSZW__content",
  "detailsContent": "RelatedSidebar-module__njuSZW__detailsContent",
  "seeMore": "RelatedSidebar-module__njuSZW__seeMore",
});
